/**
 * sessionPersistence.js — vendos sa gjatë ruhet sesioni i hyrjes.
 *
 * Web:
 *   - "Më mbaj mend" i çkyçur → cookie SESIONI (pa expires): mbijeton refresh-et
 *     dhe tab-et e reja, fshihet kur mbyllet browseri. (Më parë sessionStorage —
 *     humbte token-in me çdo rikrijim tab-i dhe bezdiste me login të përsëritur.)
 *   - "Më mbaj mend" i kyçur   → cookie 4-ditore
 *
 * Desktop (Electron — kioski i prezencës):
 *   Punëtori kyçet VETËM herën e parë. Electron i ruan cookie-t me afat
 *   skadimi në disk, ndaj një cookie afatgjatë e mban sesionin përtej
 *   rinisjeve të aplikacionit. Kërkohet kyçje e re vetëm nëse:
 *     • aplikacioni riinstalohet (userData/cookie-t fshihen), ose
 *     • ndryshohet fjalëkalimi (backend-i e revokon token-in → 401 → login).
 *
 * Importohet nga loginService.js (email/ID) dhe ssoSession.js (Google SSO),
 * që të dyja rrugët e hyrjes të sillen njësoj.
 */
import helper from './helper';

export const isElectron = () =>
  typeof window !== 'undefined' && !!window.electronAPI;

// ~1 vit — praktikisht "deri në riinstalim". I sigurt sepse backend-i e
// revokon sesionin sapo ndryshon fjalëkalimi.
const DESKTOP_SESSION_EXDAYS = 365;

/** Afati i ruajtjes: ditë për cookie me expires, ose 'session' për cookie sesioni. */
export function sessionExdays(rememberMe) {
  if (isElectron()) return DESKTOP_SESSION_EXDAYS;
  return rememberMe ? 4 : 'session';
}

/** Ruaj `logedInUser` me afatin e duhur sipas mjedisit (web vs desktop). */
export function persistLogedInUser(jsValue, rememberMe = false) {
  // Në desktop sillemi sikur "më mbaj mend" të jetë gjithmonë i kyçur.
  helper().setItem('rememberMe', rememberMe || isElectron() ? 'true' : '');
  helper().setItem('logedInUser', jsValue, sessionExdays(rememberMe));
}
